/* Actiethema (Oktober Woonmaand) – resterende dagen, dagenstrook en actievak op de productpagina. Met defer geladen,
   alleen tijdens de actie. Eén klok voor alles (elke 30 s, pauzeert als het tabblad op de achtergrond staat), geen
   observers. De zinnen zijn 1-op-1 gelijk aan snippets/hd-time.liquid en de lampjes aan snippets/hd-dagen.liquid,
   zodat er bij het laden niets verspringt; uit de cache geserveerde pagina's worden zo direct rechtgezet.
   Dagenstrook (20-10-2026): data-hd-days is het einde in ms; het aantal brandende lampjes = „nog X dagen“ (zelfde som),
   geteld vanaf het laatste lampje, zodat strook en tekst ook na de wintertijd gelijk lopen. */
(function () {
  'use strict';

  var timers = document.querySelectorAll('[data-hd-end]');
  var strips = document.querySelectorAll('[data-hd-days]');
  var deal = document.querySelector('[data-hd-deal]');
  if (!timers.length && !strips.length && !deal) return;

  function text(format, s, d, h, m) {
    if (format === 'short' || format === 'cap') {
      var t, dc = Math.ceil(s / 86400); // kalenderdagen incl. vandaag, gelijk aan de brandende lampjes
      if (d >= 1 && dc >= 2) t = 'nog ' + dc + ' dagen';
      else if (d >= 1) t = 'nog 1 dag';
      else if (h >= 1) t = 'nog ' + h + ' uur';
      else t = 'nog ' + m + ' min.';
      return format === 'cap' ? t.charAt(0).toUpperCase() + t.slice(1) : t;
    }
    if (d >= 1) return 'Actie eindigt over ' + (d === 1 ? '1 dag' : d + ' dagen') + (h > 0 ? ' en ' + h + ' uur' : '');
    if (h >= 1) return 'Actie eindigt over ' + h + ' uur en ' + m + ' min.';
    return 'Actie eindigt over ' + m + ' min.';
  }

  function set(el, sel, value) {
    var t = el.querySelector(sel);
    if (t && t.textContent !== value) t.textContent = value;
  }

  function tick() {
    var now = Date.now();
    Array.prototype.forEach.call(timers, function (el) {
      var end = Number(el.getAttribute('data-hd-end')) || 0;
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      set(el, '[data-hd-label]', s === 0 ? 'Actie afgelopen' : text(el.getAttribute('data-hd-format'), s, d, h, m));
    });
    Array.prototype.forEach.call(strips, function (el) {
      var end = Number(el.getAttribute('data-hd-days')) || 0;
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var today = el.children.length - Math.ceil(s / 86400) + 1;
      if (String(today) === el.getAttribute('data-today')) return;
      el.setAttribute('data-today', today);
      Array.prototype.forEach.call(el.children, function (dot, i) {
        dot.className = i + 1 > today ? 'on' : (i + 1 === today ? 'on today' : '');
      });
    });
  }

  tick();
  var id = setInterval(tick, 30000);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearInterval(id); } else { tick(); id = setInterval(tick, 30000); }
  });

  if (!deal) return;

  // Actievak: percentage + besparing van de gekozen variant (theme-event, zoals bij de stapeldeal).
  var ids = (deal.getAttribute('data-variant-ids') || '').split(',');

  function amount(cents) {
    cents = Math.round(cents);
    var euros = Math.floor(cents / 100), dec = String(cents % 100);
    if (dec.length < 2) dec = '0' + dec;
    return String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
  }

  document.addEventListener('product:variant-change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || ids.indexOf(String(v.id)) === -1) return;
    var price = Number(v.price) || 0, compare = Number(v.compare_at_price) || 0;
    if (compare <= price) { deal.hidden = true; return; }
    var save = compare - price;
    var pct = Math.floor((save * 200 + compare) / (compare * 2));
    set(deal, '[data-hd-deal-pct]', pct + '%');
    set(deal, '[data-hd-deal-save]', amount(save));
    deal.hidden = false;
  });
})();
